import { ClipboardPaste, StickyNote, Type, X } from "lucide-react";
import type { XYPosition } from "@xyflow/react";

interface CanvasContextMenuProps {
  screen: XYPosition;
  flow: XYPosition;
  canPaste: boolean;
  onAdd: (kind: string, position: XYPosition) => void;
  onPaste: (position: XYPosition) => void;
  onClose: () => void;
}

export function CanvasContextMenu({ screen, flow, canPaste, onAdd, onPaste, onClose }: CanvasContextMenuProps) {
  return (
    <div className="canvas-context-menu" style={{ left: screen.x, top: screen.y }} role="menu">
      <button type="button" role="menuitem" onClick={() => { onAdd("note", flow); onClose(); }}>
        <StickyNote size={14} /><span>新建便签</span><kbd>N</kbd>
      </button>
      <button type="button" role="menuitem" onClick={() => { onAdd("text", flow); onClose(); }}>
        <Type size={14} /><span>新建文本</span><kbd>T</kbd>
      </button>
      <div className="context-separator" />
      <button type="button" role="menuitem" disabled={!canPaste} onClick={() => { onPaste(flow); onClose(); }}>
        <ClipboardPaste size={14} /><span>粘贴</span><kbd>⌘V</kbd>
      </button>
      <button type="button" role="menuitem" onClick={onClose}>
        <X size={14} /><span>关闭菜单</span><kbd>Esc</kbd>
      </button>
    </div>
  );
}

